<template>
	<div class="fa-overlay" @click="$emit('close')">
		<div class="fa-modal" @click.stop>
			<!-- 标题栏 -->
			<div class="fa-header">
				<div class="fa-header-title">
					<div class="fa-icon">融</div>
					<span>金融服务分析</span>
				</div>
				<div class="fa-close" @click="$emit('close')">✕</div>
			</div>

			<!-- 内容区 -->
			<div class="fa-body">
				<!-- 核心指标卡片 -->
				<div class="fa-stats">
					<div class="fa-stat" :class="s.color" v-for="s in stats" :key="s.label">
						<div class="fa-stat-label">{{ s.label }}</div>
						<div class="fa-stat-value">{{ s.value }}<span class="fa-unit">{{ s.unit }}</span></div>
						<div class="fa-stat-compare">{{ s.compareLabel }} <span :class="s.compareClass">{{ s.compareValue }}</span></div>
					</div>
				</div>

				<!-- 重庆 vs 全国对比图 -->
				<div class="fa-chart-section">
					<div class="fa-section-title">重庆与全国关键指标对比</div>
					<div class="fa-compare" ref="compareChart"></div>
				</div>

				<!-- 底部两栏：融资渠道 + 分析结论 -->
				<div class="fa-bottom">
					<div class="fa-chart-section fa-chart-nomb">
						<div class="fa-section-title">各融资渠道成功率对比</div>
						<table class="fa-channel">
							<thead>
								<tr>
									<th>融资渠道</th>
									<th>全国成功率</th>
									<th>重庆成功率</th>
									<th>差值</th>
								</tr>
							</thead>
							<tbody>
								<tr :class="{ 'fa-total-row': row.total }" v-for="row in channels" :key="row.name">
									<td style="text-align:left;padding-left:10px;">{{ row.name }}</td>
									<td>{{ row.nat }}</td>
									<td :class="row.cqClass">{{ row.cq }}</td>
									<td :class="row.diffClass">{{ row.diff }}</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="fa-conclusion">
						<div class="fa-section-title">综合分析</div>
						<ul class="fa-conclusion-list">
							<li :class="c.type" v-for="(c, i) in conclusions" :key="i">{{ c.text }}</li>
						</ul>
					</div>
				</div>

				<!-- 数据来源/参考资料 -->
				<div class="fa-source">
					<div class="fa-section-title">数据来源与参考依据</div>
					<table class="fa-source-table">
						<thead>
							<tr>
								<th class="fa-num-col">序号</th>
								<th>主体 / 文件</th>
								<th>关键数据</th>
								<th>说明</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="src in sources" :key="src.no">
								<td class="fa-num-col">{{ src.no }}</td>
								<td>{{ src.name }}</td>
								<td>{{ src.data }}</td>
								<td>{{ src.note }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<!-- 底部状态栏 -->
			<div class="fa-footer">
				<div class="fa-update">
					<div class="fa-dot"></div>
					<span>数据更新时间：{{ updateTime }}</span>
				</div>
				<span>重庆火锅产业大脑 · 社会侧 · 金融服务</span>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	export default {
		name: 'FinanceAnalysis',
		data() {
			return {
				stats: [{
						label: '融资企业数',
						value: '97',
						unit: '家',
						color: 'blue',
						compareLabel: '全国占比',
						compareValue: '11.3%',
						compareClass: 'up'
					},
					{
						label: '融资总金额',
						value: '6.9',
						unit: '亿元',
						color: 'blue',
						compareLabel: '全国占比',
						compareValue: '11.1%',
						compareClass: 'up'
					},
					{
						label: '融资成功率',
						value: '79.0',
						unit: '%',
						color: 'green',
						compareLabel: '高于全国',
						compareValue: '+5.5pct',
						compareClass: 'up'
					},
					{
						label: '户均融资额',
						value: '101.8',
						unit: '万元',
						color: 'green',
						compareLabel: '高于全国',
						compareValue: '+41.2%',
						compareClass: 'up'
					}
				],
				channels: [{
						name: '债权融资（银行信贷）',
						nat: '76.1%',
						cq: '82.8%',
						cqClass: 'highlight',
						diff: '+6.7',
						diffClass: 'up'
					},
					{
						name: '股权融资（VC/PE）',
						nat: '7.7%',
						cq: '12.5%',
						cqClass: 'highlight',
						diff: '+4.8',
						diffClass: 'up'
					},
					{
						name: '政府补贴与贴息',
						nat: '66.2%',
						cq: '64.7%',
						cqClass: '',
						diff: '-1.5',
						diffClass: 'down'
					},
					{
						name: '供应链金融/保理',
						nat: '57.7%',
						cq: '57.9%',
						cqClass: '',
						diff: '+0.2',
						diffClass: 'up'
					},
					{
						name: '其他（产业基金/众筹）',
						nat: '17.4%',
						cq: '37.5%',
						cqClass: 'highlight',
						diff: '+20.1',
						diffClass: 'up'
					},
					{
						name: '合计',
						nat: '73.5%',
						cq: '79.0%',
						cqClass: '',
						diff: '+5.5',
						diffClass: '',
						total: true
					}
				],
				conclusions: [{
						type: 'good',
						text: '重庆融资成功率79.0%，高于全国平均5.5个百分点，金融服务效率领先全国。'
					},
					{
						type: 'good',
						text: '户均融资额101.8万元，远超全国72.1万元，单企业融资规模优势明显。'
					},
					{
						type: 'warn',
						text: '股权融资成功率仅12.5%，虽然高于全国但绝对值偏低，需拓展VC/PE渠道资源。'
					},
					{
						type: 'warn',
						text: '政府补贴成功率略低于全国，建议优化补贴政策申报引导与服务。'
					},
					{
						type: '',
						text: '债权融资为主导（占比67%），供应链金融和创新工具仍有较大发展空间。'
					}
				],
				sources: [{
						no: 1,
						name: '中国农业银行重庆市分行',
						data: '“火锅e贷”授信200亿元，已放款超30亿元；户均30万元小额特征；信用率15%',
						note: '确定债权为主、户均30万元的小额特征'
					},
					{
						no: 2,
						name: '人民网重庆（农行重庆市分行）',
						data: '“火锅全产业链授信200亿元”与“万余户、超30亿元”',
						note: '交叉印证上一条，避免单一来源'
					},
					{
						no: 3,
						name: '农行重庆大渡口支行',
						data: '2026年1—7月大渡口区食农产业产值12.7亿元，同比+10.0%；持续以“火锅e贷”等产品投放',
						note: '区县级样本，说明火锅信贷已下沉至区县'
					},
					{
						no: 4,
						name: '工商银行成都分行',
						data: '联合四川省火锅协会推出“火锅食材贷”，以流水授信、最快3日放款；单笔案例30万元，联动5000家商户、100家火锅门店',
						note: '供应链金融与协会共创模式的样本'
					},
					{
						no: 5,
						name: '辰智大数据',
						data: '2026年上半年餐饮行业28起公开融资事件，累计披露约100亿元；餐饮品牌占43%，供应商、服务商各占29%',
						note: '推算股权融资仅24起、25亿元的基数'
					},
					{
						no: 6,
						name: '红餐产业研究院《餐饮供应链发展报告2026》',
						data: '2025—2026年8月全国餐饮投融资事件150余起，供应链相关占51.9%；餐饮供应链企业存量超4万家',
						note: '确定股权资本集中于供应链环节的结构判断'
					},
					{
						no: 7,
						name: '财政部《服务业经营主体贷款贴息政策实施方案》（财金〔2025〕81号）',
						data: '餐饮住宿等服务业经营主体贷款贴息1个百分点，单户最高100万元',
						note: '解释“政府补贴户数占11.2%、金额仅0.6%”的反差'
					},
					{
						no: 8,
						name: '人民银行等六部门《关于金融支持振兴和扩大消费的指导意见》',
						data: '设立5000亿元服务消费与养老再贷款',
						note: '债权融资规模的政策来源与上限参照'
					}
				],
				myChart: null
			}
		},
		computed: {
			// 弹框左下角“数据更新时间”取当前日期
			updateTime() {
				const d = new Date()
				const p = n => (n < 10 ? '0' + n : '' + n)
				return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
			}
		},
		mounted() {
			this.initChart()
			window.addEventListener('resize', this.resize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize)
			if (this.myChart) {
				this.myChart.dispose()
				this.myChart = null
			}
		},
		methods: {
			resize() {
				if (this.myChart) this.myChart.resize()
			},
			initChart() {
				this.myChart = echarts.init(this.$refs.compareChart)
				const option = {
					tooltip: {
						trigger: 'axis',
						backgroundColor: 'rgba(10, 30, 60, 0.9)',
						borderColor: 'rgba(0, 180, 255, 0.4)',
						textStyle: {
							color: '#cce8ff',
							fontSize: 12
						},
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						data: ['全国', '重庆'],
						textStyle: {
							color: '#88bbdd',
							fontSize: 12
						},
						itemWidth: 14,
						itemHeight: 8,
						top: 0
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: 36,
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: ['经营主体总数\n(万家)', '有融资需求\n(万家)', '实际获融资\n(万家)', '需求口径\n成功率(%)', '申请口径\n成功率(%)', '融资总额\n(亿元)', '户均融资\n(万元)'],
						axisLine: {
							lineStyle: {
								color: 'rgba(0, 180, 255, 0.3)'
							}
						},
						axisLabel: {
							color: '#88bbdd',
							fontSize: 10,
							interval: 0
						}
					},
					yAxis: {
						type: 'value',
						axisLine: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(0, 180, 255, 0.1)'
							}
						},
						axisLabel: {
							color: '#88bbdd',
							fontSize: 11
						}
					},
					series: [{
							name: '全国',
							type: 'bar',
							data: [49, 14.7, 8.6, 58.5, 73.5, 620, 72.1],
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(0, 100, 200, 0.8)'
									},
									{
										offset: 1,
										color: 'rgba(0, 100, 200, 0.3)'
									}
								]),
								borderRadius: [3, 3, 0, 0]
							},
							barWidth: 18
						},
						{
							name: '重庆',
							type: 'bar',
							data: [5.8, 1.74, 1.1, 63.2, 79.0, 112, 101.8],
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#00ffcc'
									},
									{
										offset: 1,
										color: 'rgba(0, 200, 180, 0.4)'
									}
								]),
								borderRadius: [3, 3, 0, 0]
							},
							barWidth: 18
						}
					]
				}
				this.myChart.setOption(option)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.fa-overlay {
		position: fixed;
		inset: 0;
		background: rgba(3, 10, 25, 0.75);
		backdrop-filter: blur(4px);
		z-index: 3000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.fa-modal {
		position: relative;
		width: 1200px;
		max-width: 95vw;
		max-height: 92vh;
		background: linear-gradient(180deg, rgba(13, 35, 72, 0.95) 0%, rgba(8, 22, 50, 0.98) 100%);
		border: 1px solid rgba(0, 180, 255, 0.35);
		border-radius: 8px;
		box-shadow: 0 0 40px rgba(0, 150, 255, 0.25), inset 0 0 60px rgba(0, 100, 200, 0.08);
		display: flex;
		flex-direction: column;
		overflow: hidden;

		&::before,
		&::after {
			content: '';
			position: absolute;
			width: 24px;
			height: 24px;
			border: 2px solid #00d4ff;
		}

		&::before {
			top: -1px;
			left: -1px;
			border-right: none;
			border-bottom: none;
		}

		&::after {
			bottom: -1px;
			right: -1px;
			border-left: none;
			border-top: none;
		}
	}

	.fa-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 24px;
		background: linear-gradient(90deg, rgba(0, 150, 255, 0.2) 0%, transparent 100%);
		border-bottom: 1px solid rgba(0, 180, 255, 0.2);
		flex-shrink: 0;
	}

	.fa-header-title {
		display: flex;
		align-items: center;
		gap: 12px;
		font-size: 20px;
		font-weight: bold;
		color: #fff;
		letter-spacing: 2px;
	}

	.fa-icon {
		width: 28px;
		height: 28px;
		background: linear-gradient(135deg, #00d4ff, #0066ff);
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #fff;
		box-shadow: 0 0 12px rgba(0, 212, 255, 0.5);
	}

	.fa-close {
		width: 32px;
		height: 32px;
		border: 1px solid rgba(0, 180, 255, 0.4);
		background: rgba(0, 100, 200, 0.15);
		color: #88ccff;
		border-radius: 4px;
		cursor: pointer;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.2s;

		&:hover {
			background: rgba(255, 80, 80, 0.3);
			border-color: rgba(255, 100, 100, 0.6);
			color: #fff;
		}
	}

	.fa-body {
		padding: 16px 24px;
		overflow-y: auto;
		flex: 1;
	}

	.fa-stats {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 14px;
		margin-bottom: 16px;
	}

	.fa-stat {
		background: linear-gradient(135deg, rgba(0, 100, 200, 0.15) 0%, rgba(0, 50, 120, 0.1) 100%);
		border: 1px solid rgba(0, 180, 255, 0.25);
		border-radius: 6px;
		padding: 12px 14px;
		position: relative;
		overflow: hidden;

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 3px;
			height: 100%;
		}

		&.blue::before {
			background: #00d4ff;
			box-shadow: 0 0 8px #00d4ff;
		}

		&.green::before {
			background: #00ff99;
			box-shadow: 0 0 8px #00ff99;
		}

		&.orange::before {
			background: #ff9933;
			box-shadow: 0 0 8px #ff9933;
		}

		&.purple::before {
			background: #aa66ff;
			box-shadow: 0 0 8px #aa66ff;
		}
	}

	.fa-stat-label {
		font-size: 12px;
		color: #88bbdd;
		margin-bottom: 6px;
	}

	.fa-stat-value {
		font-size: 24px;
		font-weight: bold;
		color: #fff;
		line-height: 1;
		margin-bottom: 5px;
	}

	.fa-unit {
		font-size: 12px;
		font-weight: normal;
		color: #88bbdd;
		margin-left: 2px;
	}

	.fa-stat-compare {
		font-size: 11px;
		color: #88bbdd;

		.up {
			color: #00ff99;
		}

		.down {
			color: #ff6666;
		}
	}

	.fa-chart-section {
		background: rgba(0, 40, 100, 0.15);
		border: 1px solid rgba(0, 180, 255, 0.2);
		border-radius: 6px;
		padding: 12px 16px;
		margin-bottom: 16px;
	}

	.fa-chart-nomb {
		margin-bottom: 0;
	}

	.fa-section-title {
		font-size: 15px;
		color: #cce8ff;
		margin-bottom: 12px;
		padding-left: 10px;
		border-left: 3px solid #00d4ff;
		letter-spacing: 1px;
	}

	.fa-compare {
		width: 100%;
		height: 240px;
	}

	.fa-bottom {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 14px;
		margin-bottom: 16px;
	}

	.fa-channel {
		width: 100%;
		border-collapse: collapse;
		font-size: 12px;

		th {
			background: rgba(0, 100, 200, 0.3);
			color: #cce8ff;
			padding: 8px 6px;
			text-align: center;
			font-weight: normal;
			border: 1px solid rgba(0, 180, 255, 0.2);
		}

		td {
			padding: 7px 6px;
			text-align: center;
			color: #aaccee;
			border: 1px solid rgba(0, 180, 255, 0.15);
		}

		tr:hover td {
			background: rgba(0, 100, 200, 0.15);
		}

		.highlight {
			color: #00ffcc;
			font-weight: bold;
		}

		.up {
			color: #00ff99;
		}

		.down {
			color: #ff6666;
		}

		.fa-total-row td {
			background: rgba(0, 100, 200, 0.25);
			color: #fff;
			font-weight: bold;
		}
	}

	.fa-conclusion {
		background: rgba(0, 40, 100, 0.15);
		border: 1px solid rgba(0, 180, 255, 0.2);
		border-radius: 6px;
		padding: 16px;
	}

	.fa-conclusion-list {
		list-style: none;
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 0;
		margin: 0;

		li {
			font-size: 12px;
			color: #aaccee;
			line-height: 1.6;
			padding-left: 16px;
			position: relative;

			&::before {
				content: '';
				position: absolute;
				left: 0;
				top: 7px;
				width: 6px;
				height: 6px;
				background: #00d4ff;
				border-radius: 50%;
				box-shadow: 0 0 6px #00d4ff;
			}

			&.warn::before {
				background: #ff9933;
				box-shadow: 0 0 6px #ff9933;
			}

			&.good::before {
				background: #00ff99;
				box-shadow: 0 0 6px #00ff99;
			}
		}
	}

	.fa-source {
		background: rgba(0, 40, 100, 0.15);
		border: 1px solid rgba(0, 180, 255, 0.2);
		border-radius: 6px;
		padding: 16px;
		margin-top: 16px;
	}

	.fa-source-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 11px;

		th {
			background: rgba(0, 100, 200, 0.3);
			color: #cce8ff;
			padding: 6px 8px;
			text-align: left;
			font-weight: normal;
			border: 1px solid rgba(0, 180, 255, 0.2);
		}

		td {
			padding: 6px 8px;
			color: #aaccee;
			border: 1px solid rgba(0, 180, 255, 0.15);
			line-height: 1.5;
		}

		.fa-num-col {
			width: 30px;
			text-align: center;
		}
	}

	.fa-footer {
		padding: 10px 24px;
		border-top: 1px solid rgba(0, 180, 255, 0.15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 12px;
		color: #6699bb;
		flex-shrink: 0;
	}

	.fa-update {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.fa-dot {
		width: 6px;
		height: 6px;
		background: #00ff99;
		border-radius: 50%;
		animation: faPulse 2s infinite;
	}

	@keyframes faPulse {

		0%,
		100% {
			opacity: 1;
		}

		50% {
			opacity: 0.4;
		}
	}

	.fa-body::-webkit-scrollbar {
		width: 6px;
	}

	.fa-body::-webkit-scrollbar-track {
		background: rgba(0, 50, 120, 0.2);
	}

	.fa-body::-webkit-scrollbar-thumb {
		background: rgba(0, 180, 255, 0.3);
		border-radius: 3px;
	}
</style>
